module.exports = __webpack_public_path__ + "static/media/wolffox7_preview.1781a313.jpg";